import React from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Button, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useMe } from '../../../hooks/useMe'

// The registry gates this on the parcel's status and the user's
// `specifyNewCompartment`. It lets the statuses that mean the parcel is already
// in a compartment through for everyone, because criteria are an AND of terms
// and cannot say "on its way, or in a compartment when you are a super user" —
// so the super-user half of that is the check below.
//
// Moving a parcel that is already in a compartment is a different thing from
// moving one still on its way: someone has to go and physically fetch it. That
// is why it is the super user's to do and nobody else's. `marked-for-return`
// counts as in a compartment — the parcel is still sitting in one, waiting to be
// taken back — and iBoxen asked to be able to move those too.
export default function Reallocate({ parcel }) {
  const { t } = useTranslation('parcels')
  const dispatch = useDispatch()
  const history = useHistory()
  const { user } = useMe()

  // The location modal is drawn by CarrierHome from this redux state, and this
  // page is not under CarrierHome. So the state is set first and the page then
  // goes to /carrier, where CarrierHome mounts and finds the modal asked for.
  const reallocate = () => {
    dispatch({
      type: 'setShowModal',
      payload: {
        modal: 'location',
        selectedParcel: parcel._id,
        // LocationModal calls toString() on this, and would throw after the
        // navigation rather than here, so a parcel without `locationId` falls
        // back to the same id on its location
        selectedLocation: parcel.locationId ?? parcel.location?._id,
      },
    })
    history.push('/carrier')
  }

  const inACompartment = ['in-box', 'marked-for-return'].includes(
    parcel.currentStatus
  )
  if (inACompartment && !user.isSuperUser) return null

  return (
    <Stack spacing={2} alignItems="center">
      <Typography variant="h6" align="center">
        {t('reallocate.title')}
      </Typography>
      <Button
        variant="contained"
        color="iboxen"
        size="small"
        onClick={reallocate}
      >
        {t('reallocate.button')}
      </Button>
    </Stack>
  )
}
